import { Component } from '@angular/core';

@Component({
    selector: 'ui-svg-icon-docs-preview',
    templateUrl: './svg-icon.docs.preview.html',
    styleUrls: ['./svg-icon.docs.preview.scss'],
})
export class UISvgIconDocsPreview {

}
